import { render, staticRenderFns } from "./PaymentPsd2Data.vue?vue&type=template&id=196c88ba"
import script from "./PaymentPsd2Data.vue?vue&type=script&lang=js"
export * from "./PaymentPsd2Data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports